import { setLoggedIn, setUser } from "store/user/user-actions";
import { RoutesApi } from "../api/routes.api.service";

export class RoutesStore extends RoutesApi {}
